import { render, staticRenderFns } from "./BankDataModal.vue?vue&type=template&id=3036ab28&scoped=true&"
import script from "./BankDataModal.vue?vue&type=script&lang=js&"
export * from "./BankDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036ab28",
  null
  
)

export default component.exports